// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var AssetClass;
(function (AssetClass) {
    AssetClass["PE"] = "PE";
    AssetClass["RE"] = "RE";
    AssetClass["PD"] = "PD";
    AssetClass["INFRA"] = "INFRA";
    AssetClass["SEC"] = "SEC";
    AssetClass["ALL"] = "ALL";
})(AssetClass || (AssetClass = {}));
export function AssetClassFromJSON(json) {
    return json;
}
export function AssetClassToJSON(value) {
    return value;
}
